import React from 'react';
import './Modal.css';

const Modal = ({ open, title, children, onClose }) => {
    if (!open) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-box">
                <h3>{title}</h3>
                {children}
                <button className="btn-outline mt-2" onClick={onClose}>
                    Close
                </button>
            </div>
        </div>
    );
};

export default Modal;
